const COMPANIES_TABLE_FIELDS = [
  {
    name: '#',
    class: 'table-cell align-middle w-1/6 pl-8 cursor-pointer',
    sortKey: 'id',
    displayField: 'id',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Name',
    class: 'table-cell align-middle w-1/3 cursor-pointer',
    sortKey: 'name',
    displayField: 'name',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Type',
    class: 'table-cell align-middle w-1/3 cursor-pointer capitalize',
    sortKey: 'type',
    displayField: 'type',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Updated',
    class: 'table-cell align-middle w-1/3 cursor-pointer',
    sortKey: 'updated_at',
    displayField: 'updated_at',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Actions',
    displayField: 'Actions',
    class: 'table-cell align-middle w-1/6 text-right pr-8',
  },
]

const USERS_TABLE_FIELDS = [
  {
    name: '#',
    class: 'table-cell align-middle w-1/12 pl-8 cursor-pointer',
    sortKey: 'id',
    displayField: 'id',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Name',
    class: 'table-cell align-middle w-1/4 cursor-pointer',
    sortKey: 'name',
    displayField: 'name',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Email',
    class: 'table-cell align-middle w-1/4 cursor-pointer',
    sortKey: 'email',
    displayField: 'email',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Updated',
    class: 'table-cell align-middle w-1/4 cursor-pointer',
    sortKey: 'updated_at',
    displayField: 'updated_at',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Actions',
    displayField: 'Actions',
    class: 'table-cell align-middle w-1/6 text-right pr-8',
  },
]

const GROUPS_TABLE_FIELDS = [
  {
    name: '#',
    class: 'table-cell align-middle w-1/6 pl-8 cursor-pointer',
    sortKey: 'id',
    displayField: 'id',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Name',
    class: 'table-cell align-middle w-1/3 cursor-pointer',
    sortKey: 'name',
    displayField: 'name',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Updated',
    class: 'table-cell align-middle w-1/3 cursor-pointer',
    sortKey: 'updated_at',
    displayField: 'updated_at',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Actions',
    displayField: 'Actions',
    class: 'table-cell align-middle w-1/6 text-right pr-8',
  },
]

const INDIVIDUALS_REPORTS_TABLE_FIELDS = [
  {
    name: 'User',
    class: 'table-cell align-middle w-1/6 pl-8 cursor-pointer',
    sortKey: 'userName',
    displayField: 'userName',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Volunteer Hours',
    class: 'table-cell align-middle w-1/6 cursor-pointer pl-2',
    sortKey: 'volunteerHours',
    displayField: 'volunteerHours',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'PENCIL Positives',
    class: 'table-cell align-middle w-1/6 cursor-pointer pl-2',
    sortKey: 'actsOfKyndness',
    displayField: 'actsOfKyndness',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Gratitude',
    class: 'table-cell align-middle w-1/6 cursor-pointer pl-2',
    sortKey: 'gratitude',
    displayField: 'gratitude',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Donations',
    class: 'table-cell align-middle w-1/6 cursor-pointer pl-2',
    sortKey: 'donationDollars',
    displayField: 'donationDollars',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Events Attended',
    class: 'table-cell align-middle w-1/6 cursor-pointer pl-2',
    sortKey: 'eventsAttended',
    displayField: 'eventsAttended',
    sortOrder: ['desc', 'asc'],
  },
]

export {
  COMPANIES_TABLE_FIELDS,
  USERS_TABLE_FIELDS,
  GROUPS_TABLE_FIELDS,
  INDIVIDUALS_REPORTS_TABLE_FIELDS,
}
